export default __webpack_public_path__ + "static/media/lipstick-bright-winter.06a8633b.png";